export function isValidSwift(swift?: string): boolean {
  const swiftRegex = /^([a-zA-Z]{4})([a-zA-Z]{2})([0-9a-zA-Z]{2})([0-9a-zA-Z]{3})?$/;

  if(!swift) return false;

  if(swift.length != 8 && swift.length != 11) return false;

  if(!swiftRegex.test(swift)) return false;

  return true;
}
